export default __webpack_public_path__ + "static/infographic-freshms-arrows-f0e27fcf498a1e6702c7986f82f0be0e.svg";